import { Button } from "../../../../components/button.jsx";

export function Step0({ setStep }) {
  return (
    <div className={"flex flex-col gap-3 text-center"}>
      <div style={{ fontSize: 50 }}>🪄</div>
      <div className={"font-bold"}>Welcome on board!</div>
      <div>
        Welcome to Lancerkit, and thank you for signing up to our application.
        Before starting, let's ask us a few questions in order to customize your
        experience.
      </div>
      <small>Don't worry, you'll be able to change your answers later</small>
      <Button onClick={() => setStep(1)}>start</Button>
    </div>
  );
}
